
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'

export const UNSUBSCRIBE = loadTypes('UNSUBSCRIBE')

const initialState = {
  isFetching: false,
  successMessage: null,
  errorMessage: null
}

export default function unsubscribe(state = initialState, action) {
  switch (action.type) {
    case UNSUBSCRIBE.REQUEST:
      return {
        ...state,
        isFetching: true,
        successMessage: null,
        errorMessage: null
      }

    case UNSUBSCRIBE.SUCCESS:
      return {
        ...state,
        isFetching: false,
        successMessage: action.response.success,
        errorMessage: null
      }

    case UNSUBSCRIBE.FAILURE:
      return {
        ...state,
        isFetching: false,
        successMessage: null,
        errorMessage: action.message
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/unsubscribe/index.js